import { memo, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { File as GenericFileIcon } from 'react-feather';
import { FileIcon } from '@trinity/chat-components/components/icons/File/index.js';
/* import useProjectState from '@/containers/GroupProject/hooks/useProjectState'; */
import type { IWorkspaceFileItem } from '@/types/workspace.table';
import { cx, getLocationFor } from '@trinity/chat-components';
import { formatCreatedOnDate } from './Files.Table.Grid.utils';
import styles from './style/Files.Table.Grid.module.css';

type Props = {
  item: IWorkspaceFileItem;
};

export const File = ({ item }: Props) => {
  const to = getLocationFor.workspaces.file({
    fileId: item.file.id,
  });

  const createdOn = useMemo(() => {
    return formatCreatedOnDate(item.file.publishedOn || item.object.createdOn);
  }, [
    item.object.createdOn,
    item.file.publishedOn,
  ]);

  return (
    <Link
      className={cx(styles.link, styles.file)}
      to={to}
      draggable={false}>
      <div className={styles.iconThumb}>
        <FileIcon
          className={styles.iconFile}
          extension={item.file.extension} />
      </div>
      <div className={styles.info}>
        <div className={styles.details}>
          <div className={styles.name}>{item.file.name}</div>
          <div className={styles.lastModified}>{createdOn}</div>
        </div>
      </div>
    </Link>
  );
};

const GenericFileThumb = memo(() => {
  return (
    <div className={styles.genericThumb}>
      <GenericFileIcon className={styles.icon} />
    </div>
  );
});